import { componentProvider } from 'js-component-framework';
import ModalAccess from './modal-access';
import './modal-access.scss';

const modalAccessConfig = {
  name: 'modal-access',
  component: ModalAccess,
};

componentProvider(modalAccessConfig);
